import { api_request } from '../axios_client';
import { handleError } from '../common';
import * as Constants from '../constants';

const isMDM = true;
const vendorAgreementCheckGet = async (options) => {
  const resourcePath = `${Constants.PATH.MDM.VENDOR_AGREEMENT.check}`;

  try {
    const res = await api_request({
      methodType: 'get',
      resourcePath,
      options,
      isMDM
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const vendorAgreementAcceptPost = async (agreementId, options) => {
  const resourcePath = `${Constants.PATH.MDM.VENDOR_AGREEMENT.accept}/${agreementId}`;

  try {
    const res = await api_request({
      methodType: 'post',
      resourcePath,
      options,
      isMDM
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

export { vendorAgreementCheckGet, vendorAgreementAcceptPost };
